import {
    ForumFeedFetchFailureAction,
    ForumFeedFetchRequestAction,
    ForumFeedFetchSuccessAction,
    FORUM_FEED_FETCH_FAILURE,
    FORUM_FEED_FETCH_REQUEST,
    FORUM_FEED_FETCH_SUCCESS,
} from 'mk2/apps/forum/containers/ForumFeed/ForumFeed.actions';
import { tupdate } from 'mk2/helpers/types';
import infiniteList, { State as InfiniteListState } from 'mk2/reducers/infiniteList';
import { Reducer } from 'redux';

export const ORDER_BY_NEWEST = 'newest';
export const ORDER_BY_UPDATED = 'updated';

export type OrderBy = typeof ORDER_BY_NEWEST | typeof ORDER_BY_UPDATED;

export type ForumFeedInfiniteListState = InfiniteListState;

const forumFeedInfiniteListReducer = infiniteList<ForumFeedFetchRequestAction, ForumFeedFetchSuccessAction, ForumFeedFetchFailureAction>(
    'FORUM_FEED_FETCH',
    (a) => a.response.result.posts,
);

type ForumFeedByOrderingState = {
    [orderBy in OrderBy]?: ForumFeedInfiniteListState;
};

export interface ForumFeedPageState {
    orders: ForumFeedByOrderingState;
    topicsCount: number;
    activeBrandDaysCampaignId: number;
    activeBrandDaysPostsIds: number[];
}

export const initialForumFeedPageState: ForumFeedPageState = {
    orders: {},
    topicsCount: null,
    activeBrandDaysCampaignId: null,
    activeBrandDaysPostsIds: [],
};

declare type ForumFeedPageReducerAction =
    ForumFeedFetchFailureAction
    | ForumFeedFetchRequestAction
    | ForumFeedFetchSuccessAction;

const forumFeedPageReducer: Reducer<ForumFeedPageState> = (state = initialForumFeedPageState, action: ForumFeedPageReducerAction) => {
    switch (action.type) {
        case FORUM_FEED_FETCH_FAILURE:
        case FORUM_FEED_FETCH_REQUEST:
            return tupdate(state, {
                orders: tupdate(state.orders, {
                    [action.orderBy]: forumFeedInfiniteListReducer(state.orders[action.orderBy], action),
                }),
            });

        case FORUM_FEED_FETCH_SUCCESS:
            return tupdate(state, {
                orders: tupdate(state.orders, {
                    [action.orderBy]: forumFeedInfiniteListReducer(state.orders[action.orderBy], action),
                }),
                topicsCount: action.topicsCount,
                activeBrandDaysCampaignId: action.response.result.activeBrandDays.campaign,
                activeBrandDaysPostsIds: action.response.result.activeBrandDays.posts,
            });

        default:
            return state;
    }
};

export default forumFeedPageReducer;
